// import external dependencies
// import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import obtenirLeLabel from './routes/label';
import contact from './routes/contact';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // Obtenir le label
  obtenirLeLabel,
  getTheLabel: obtenirLeLabel,
  dasLabelBeantragen: obtenirLeLabel,
  deLabelKreien: obtenirLeLabel,
  // Contact
  contact,
  kontakt: contact,
});

// Load Events
document.addEventListener('DOMContentLoaded', () => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js